import { toast } from "react-toastify";
import { SectionAPI } from "../constants/apiRoutes";
import { sectionActions } from "../reducers/section";
import apiService from "../utils/configAxios";
import { handleError } from "../utils/handleError";

export const updateSection = (data, navigate, id) => {
  return (dispatch) => {
    return apiService
      .put(SectionAPI.update(id), data)
      .then((response) => {
        toast.success("Uspešno ste izmenili sekciju", {
          theme: "colored",
        });
        navigate("/section-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchSectionList = () => {
  return (dispatch) => {
    return apiService
      .get(SectionAPI.list())
      .then((response) => {
        dispatch(sectionActions.fetchSectionList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchSectionById = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(SectionAPI.getById(id))
      .then((response) => {
        dispatch(sectionActions.fetchSectionDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
